import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import { useTranslations } from 'next-intl';
import { PatternFormat } from 'react-number-format';

import { useAppSelector } from 'store';

import { getPlatform } from 'modules/global';

import { useCheckSms } from '../hooks';

const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return '';

  const countryCode = phoneNumber.slice(0, 4);
  const operatorCode = phoneNumber.slice(4, 6);
  const maskedPart = '***';
  const lastPart1 = phoneNumber.slice(9, 11);
  const lastPart2 = phoneNumber.slice(11, 13);

  return `${countryCode} (${operatorCode}) ${maskedPart} ${lastPart1} ${lastPart2}`;
};

const OtpStep: React.FC = () => {
  const t = useTranslations('auth');
  const [form] = Form.useForm();
  const phone = useAppSelector(state => state.authModal.data.phone);
  const routeLoading = useAppSelector(state => state.routeLoading.isRouteLoading);
  const { mutate, isLoading } = useCheckSms();

  const onFinish = (values: { code: string }) => {
    mutate({ phone, code: values.code, platform: getPlatform() });
  };

  useEffect(() => {
    const readOtpFromSms = async () => {
      if ('OTPCredential' in window || (navigator as any).credentials) {
        try {
          const content = await (navigator as any).credentials.get({
            otp: { transport: ['sms'] },
            signal: new AbortController().signal
          });

          if (content && 'code' in content) {
            form.setFieldsValue({ code: content.code });
            form.submit();
          }
        } catch (err) {
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.log('Web OTP API error or user dismissed:', err);
          }
        }
      }
    };

    readOtpFromSms();
  }, [form]);

  return (
    <div className="flex h-1/2 w-full items-center justify-center sm:h-full">
      <div className="item-center max-w-100 flex flex-col justify-center">
        <h2 className="mb-4 text-2xl font-semibold">{t('otp_title')} 📨</h2>
        <p className="mb-4 text-gray-600">
          {formatPhoneNumber(phone)} {t('otp_desc')}
        </p>

        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="code"
            rules={[
              { required: true, message: t('otp_validation_message') },
              { len: 5, message: t('otp_validation_message') }
            ]}
          >
            <PatternFormat
              format="#####"
              autoFocus
              mask="_"
              allowEmptyFormatting
              placeholder="_ _ _ _ _"
              className="!h-13 w-full !rounded-xl !border-transparent !bg-gray-100 !p-3 hover:!outline-green-500 focus:!outline-green-500"
            />
          </Form.Item>

          <Button
            loading={isLoading || routeLoading}
            htmlType="submit"
            className="!py-5.5 !w-full !rounded-lg !border-none !bg-green-500 !text-white"
          >
            {t('kirish')}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default OtpStep;
